// https://storybook.js.org/tutorials/design-systems-for-developers/react/en/build/
import styled, {css} from "styled-components";
import {GatsbyImage} from "gatsby-plugin-image";

// dont files is a local woff
// export const fontUrl = 'https://fonts.googleapis.com/css?family=Nunito+Sans:400,700,800,900';


export const Section = styled.section`
  width: 100%;
  padding: 2rem 0;
  position: relative;
`;

export const Container = styled.div`
  max-width: var(--content-width-max);
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 1;
  @media(min-width: 768px) {
    padding: 0 1rem;
  }
`;

export const NarrowContainer = styled(Container)`
  @media (min-width: 768px) {
    padding: 0 4rem;
  }
  @media (min-width: 1600px) { --content-width-max: 1020px; }
`

export const BackgroundImage = styled(GatsbyImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
`;


export const backgroundElement = css`
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  z-index: 0;

  video, iFrame{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const GreyBackground = css`
  background-color: var(--offwhite);
`;

export const GreyWhiteSplitBkg = css`
  background: linear-gradient(0deg, #fff 50%, #E9ECEF 50%)
`
export const WhiteGreySplitBkg = css`
  background: linear-gradient(180deg, #fff 50%, #E9ECEF 50%)
`

// export const TextCenter = css`
//   text-align: center;
// `;

// export const TextLeft = css`
//   text-align: left;
// `;

// export const TextRight = css`
//   text-align: right;
// `;
